exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".DialogTitleBar_titleBar__2KVye{background-color:#fff;height:3rem;display:flex;justify-content:space-between;align-items:center;padding:0 1rem;z-index:1}.DialogTitleBar_title__29SiO{flex-grow:1;font-size:1.25rem}.DialogTitleBar_title__29SiO h1,.DialogTitleBar_title__29SiO h2{font-size:1.25rem;margin:0;padding:0}.DialogTitleBar_actions__22Xed{padding:.5rem 1rem;display:flex;justify-content:space-between;flex:0 0 auto;flex-wrap:wrap}.DialogTitleBar_actions__22Xed>*{margin-left:.5rem}", ""]);

// exports
exports.locals = {
	"titleBar": "DialogTitleBar_titleBar__2KVye",
	"title": "DialogTitleBar_title__29SiO",
	"actions": "DialogTitleBar_actions__22Xed"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/DialogLayout/Custom/DialogTitleBar.less
// module id = 2067
// module chunks = 8